const TAB_KEY_CODE = 9;

export default function forceCircularTabbing(domElement = document): void {
    domElement.addEventListener("keydown", (event) => {
        const focusableElements = getFocusableElementsInOrder(domElement);

        if (shouldFocusLast(event, focusableElements)) {
            event.preventDefault();
            focusableElements[focusableElements.length - 1].focus();

            return;
        }

        if (shouldFocusFirst(event, focusableElements)) {
            event.preventDefault();
            focusableElements[0].focus();
        }
    });
}

function shouldFocusLast(event: KeyboardEvent, focusableElements: NodeListOf<Element>): boolean {
    return isBackwardTab(event) && (document.activeElement === focusableElements[0] || isFocusOnScreen());
}

function shouldFocusFirst(event: KeyboardEvent, focusableElements: NodeListOf<Element>): boolean {
    return isForwardTab(event) && (
        document.activeElement === focusableElements[focusableElements.length - 1]
        || isFocusOnScreen()
    );
}

// Necessary for when a new screen in the iframe is loaded and no element is autoFocused
function isFocusOnScreen(): boolean {
    return document.activeElement === document.querySelector("body");
}

function isBackwardTab(event: KeyboardEvent): boolean {
    return event.keyCode === TAB_KEY_CODE && event.shiftKey;
}

function isForwardTab(event: KeyboardEvent): boolean {
    return event.keyCode === TAB_KEY_CODE && !event.shiftKey;
}

function getFocusableElementsInOrder(domElement: Document): NodeListOf<HTMLElement> {
    return domElement.querySelectorAll<HTMLElement>("button, a[href]:not(:empty), input:not([type=\"hidden\"]), select, textarea, [tabindex]:not([tabindex=\"-1\"])");
}
